import { Link } from 'react-router-dom';
import { Button, Card, Grid } from "@material-ui/core";
import { ArrowBack } from '@material-ui/icons';
import {makeStyles} from "@material-ui/core/styles";

import MenuCategory from "./menuCategory";

const useStyles = makeStyles({
  root: {
    color: 'black',
    backgroundColor: 'white',
    // border: '1px solid red',
  },
  camera: {
    float: 'right',
    paddingTop: '10px',
    '&:hover': {
      cursor: 'pointer'
    },
  }
});

const BeveragesMenuContainer = ({ selectItem }) => {
  const classes = useStyles();

  const handleCameraClick = (item) => {
    selectItem(item);
  }

  return (
    <Card className={classes.root}>
      <Grid container justify='space-evenly'>
        <Grid item xs={12}>
          <div style={{ marginTop: '10px' }}>
            <Link to="/menu">
              <Button
                variant="text"
                color="secondary"
                startIcon={<ArrowBack />}
              >
                Back to the food
              </Button>
            </Link>
          </div>
        </Grid>

        <Grid item xs={12} style={{ textAlign: 'center' }}>
          <a
            href="https://castanedatacos-imgs.s3.us-east-2.amazonaws.com/Castaneda_Tacos_Drinks_PDF.pdf"
            target="_blank"
            rel="noreferrer"
          >
            <Button variant="outlined" color="secondary" style={{ marginTop: '15px' }}>View/Download Drinks PDF</Button>
          </a>
        </Grid>

        <MenuCategory categoryId={1} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={2} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={3} size="lg" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={4} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={5} size="lg" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={6} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={7} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />
        <MenuCategory categoryId={8} size="sm" handleCameraClick={handleCameraClick} beverageView={true} />

      </Grid>
    </Card>
  );
};

export default BeveragesMenuContainer;
